import Image from 'next/legacy/image';
import Customize from './Customize';

export default function BeehiivCreate() {
  return (
    <li>
      <h3 id="setup-and-customise">Setup and Customise</h3>
      <p>Setup your newsletter by giving us the beehiiv newsletter URL.</p>
      <p>
        Click on the <code>Add</code> button to finish.
      </p>
      <Image
        src="/guides/beehiiv-create.jpg"
        width={1502}
        height={996}
        alt="screenshot of add newsletter modal"
      />
      <Customize />
    </li>
  );
}
